export class CancelDeliveryReasonMiniEntity {
  id?: number
  text?: string | null
}

